const DISMISS_KEY = "imonimon_install_prompt_dismissed_at";
const DISMISS_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

function isIosDevice() {
  const ua = window.navigator.userAgent || "";
  const platform = window.navigator.platform || "";
  const iDevice = /iPhone|iPad|iPod/i.test(ua);
  const ipadDesktop = platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
  return iDevice || ipadDesktop;
}

function isAndroidDevice() {
  return /Android/i.test(window.navigator.userAgent || "");
}

function recentlyDismissed() {
  const value = window.localStorage.getItem(DISMISS_KEY);
  if (!value) return false;

  const timestamp = Number.parseInt(value, 10);
  if (!Number.isFinite(timestamp)) return false;

  return Date.now() - timestamp < DISMISS_WINDOW_MS;
}

function markDismissed() {
  window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
}

function removePromptUi() {
  const banner = document.getElementById("install-prompt-banner");
  if (banner) banner.remove();
}

function removeIosPromptSheet() {
  const sheet = document.getElementById("install-prompt-ios-sheet");
  if (sheet) sheet.remove();
}

function isCapacitorNativeRuntime() {
  if (document.documentElement?.dataset?.nativeRuntime === "true") return true;

  const protocol = window.location?.protocol;
  if (protocol === "capacitor:" || protocol === "ionic:") return true;

  if (/\bCapacitor\b/i.test(window.navigator?.userAgent || "")) return true;

  const capacitor = window.Capacitor;
  if (!capacitor || typeof capacitor !== "object") return false;

  if (typeof capacitor.isNativePlatform === "function") {
    try {
      return capacitor.isNativePlatform();
    } catch (_error) {
      // fallback checks below
    }
  }

  if (typeof capacitor.getPlatform === "function") {
    try {
      return capacitor.getPlatform() !== "web";
    } catch (_error) {
      // fallback checks below
    }
  }

  return capacitor.platform === "ios" || capacitor.platform === "android";
}

function showIosInstructions() {
  const existing = document.getElementById("install-prompt-ios-sheet");
  if (existing) existing.remove();

  const sheet = document.createElement("div");
  sheet.id = "install-prompt-ios-sheet";
  sheet.className = "install-prompt-sheet-backdrop";
  sheet.innerHTML = `
    <div class="install-prompt-sheet" role="dialog" aria-modal="true" aria-label="Install ImOnImOn">
      <h3>Install ImOnImOn</h3>
      <p>On iPhone:</p>
      <ol>
        <li>Tap the Share button in Safari.</li>
        <li>Choose <strong>Add to Home Screen</strong>.</li>
        <li>Tap <strong>Add</strong>.</li>
      </ol>
      <button type="button" class="install-prompt-action">Got it</button>
    </div>
  `;

  sheet.addEventListener("click", (event) => {
    if (event.target === sheet) sheet.remove();
  });

  const closeButton = sheet.querySelector(".install-prompt-action");
  closeButton?.addEventListener("click", () => sheet.remove());
  document.body.appendChild(sheet);
}

function renderPrompt({ actionLabel, onAction }) {
  removePromptUi();

  const banner = document.createElement("div");
  banner.id = "install-prompt-banner";
  banner.className = "install-prompt-banner";
  banner.innerHTML = `
    <div class="install-prompt-icon" aria-hidden="true">🎣</div>
    <div class="install-prompt-copy">
      <p class="install-prompt-title">Install ImOnImOn</p>
      <p class="install-prompt-subtitle">${window.location.host}</p>
    </div>
    <button type="button" class="install-prompt-action">${actionLabel}</button>
    <button type="button" class="install-prompt-close" aria-label="Dismiss install prompt">×</button>
  `;

  banner.querySelector(".install-prompt-action")?.addEventListener("click", onAction);
  banner.querySelector(".install-prompt-close")?.addEventListener("click", () => {
    markDismissed();
    removePromptUi();
  });

  document.body.appendChild(banner);
}

function registerServiceWorker() {
  const canRegister =
    "serviceWorker" in window.navigator &&
    (window.location.protocol === "https:" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  if (!canRegister) return;

  window.navigator.serviceWorker.register("/sw.js").catch(() => {
    // Best effort only.
  });
}

export function setupInstallPrompt() {
  if (window.__imonimonInstallPromptInitialized) return;
  window.__imonimonInstallPromptInitialized = true;

  if (isCapacitorNativeRuntime()) {
    removePromptUi();
    removeIosPromptSheet();
    return;
  }

  registerServiceWorker();

  if (isStandalone() || recentlyDismissed()) return;

  let deferredPromptEvent = null;

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPromptEvent = event;

    renderPrompt({
      actionLabel: "Install",
      onAction: async () => {
        if (!deferredPromptEvent) return;
        deferredPromptEvent.prompt();
        try {
          await deferredPromptEvent.userChoice;
        } catch (_error) {
          // ignored
        }
        deferredPromptEvent = null;
        removePromptUi();
      }
    });
  });

  window.addEventListener("appinstalled", () => {
    removePromptUi();
  });

  if (isIosDevice() && !isStandalone()) {
    window.setTimeout(() => {
      if (document.getElementById("install-prompt-banner")) return;
      renderPrompt({
        actionLabel: "Install",
        onAction: () => {
          showIosInstructions();
        }
      });
    }, 900);
  } else if (isAndroidDevice()) {
    // On Android we wait for `beforeinstallprompt`.
  }
}
